import { createFileRoute } from '@tanstack/react-router';
import { AmforiSyncReport } from '@/app/(client)/network/-components/companyProfileTabs/integrations/report/AmforiSyncReport';

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/integrations/history/$syncHistoryId/',
)({
  component: AmforiSyncReportRoute,
});

/** Kept alongside the `/company-settings` route of the same page for deep
 *  links that predate Company Settings. `$companyId` is not read: the report
 *  resolves its company from the session, the same as the other route. */
function AmforiSyncReportRoute() {
  const { syncHistoryId } = Route.useParams();
  return <AmforiSyncReport syncHistoryId={syncHistoryId} />;
}
